<template>
  <div class="bq-product-jkgl">
    <SectionTitle :title="'产品简介'" noSpacing></SectionTitle>
    <p class="title-desc">
      健康管理是以预防和控制疾病发生与发展，降低医疗费用，提高生命质量为目的，针对个体及群体进行健康管理教育，提高自我管理意识和水平，并对其生活方式相关的健康危险因素，通过健康信息采集、健康检测、健康评估、个性化监看管理方案、健康干预等手段持续加以改善的过程和方法。
    </p>
    <div class="desc-list">
      <div class="desc-item">
        <h3>检测</h3>
        <div class="desc-mid">
          <span>信息收集</span>
          <span>健康档案</span>
        </div>
        <div class="desc-bot">
          <p>既往病史/生活方式</p>
          <p>饮食习惯/运动状态</p>
          <p>个人信息/指标数据</p>
        </div>
      </div>
      <div class="desc-item">
        <h3>评估</h3>
        <div class="desc-mid">
          <span>健康风险评估</span>
          <span>健康评价</span>
        </div>
        <div class="desc-bot">
          <p>健康问卷</p>
          <p>健康评估模型</p>
          <p>医疗数据库/医学知识库</p>
        </div>
      </div>
      <div class="desc-item">
        <h3>干预</h3>
        <div class="desc-mid">
          <span>医疗干预</span>
          <span>生活方式干预</span>
        </div>
        <div class="desc-bot">
          <p>药物干预 医生干预/心理干预 生理干预</p>
          <p>用药 跟踪随访 心理健康</p>
          <p>饮食 运动 生活习惯 健康教育</p>
        </div>
      </div>
    </div>
    <div class="product-item">
      <div>
        <h3>慢病管理</h3>
        <p>
          包括高血压管理、糖尿病管理和卒中管理。通过用户手动记录或设备导入数据或接入医院就诊数据，管理相应指标，系统会根据健康评估模型评估用户慢病状态，根据评估结果给予相应的健康干预方案。用户可查看指标的趋势图，了解健康状态走势，通过系统知识库给的健康建议进行健康管理，控制改善慢病。
        </p>
      </div>
      <img
        src="https://img.alicdn.com/tfs/TB1PHlIEfb2gK0jSZK9XXaEgFXa-864-464.png"
        alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
      />
    </div>
    <div class="product-item">
      <img
        src="https://img.alicdn.com/tfs/TB1TGqPDFY7gK0jSZKzXXaikpXa-432-232.png"
        alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
      />
      <div>
        <h3>疾病风险评估</h3>
        <p>
          包括亚健康风险评估、乳腺癌风险评估、慢阻肺风险评估、乙肝肝癌风险评估和结直肠癌风险评估，依据专业的疾病评估模型，预测用户患病概率，通过评估结果给予用户相关预防或改善的健康建议。
        </p>
      </div>
    </div>
    <div class="product-item">
      <div>
        <h3>健康知识库</h3>
        <p>
          健康知识库中有大量专业的医学资讯和健康知识，包括疾病百科、重症指南、食材营养、疫苗知识和通用健康资讯。主要包含两方面：健康教育能力和底层能力。
          健康教育能力，知识库直接服务于用户，让用户了解到专业的医学知识和有趣的、与生活息息相关的健康资讯，对用户进行健康教育，从而提高用户自我管理健康的水平；底层能力，知识库为健康管理中评估模型的底层能力，知识库提供医疗健康方面的知识内容，为搭建健康评估模型提供专业内容作为依据，增加健康管理产品的权威性。
        </p>
      </div>
      <img
        src="https://img.alicdn.com/tfs/TB1PXyQDND1gK0jSZFsXXbldVXa-432-232.png"
        alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
      />
    </div>
    <SectionTitle :title="'产品优势'" noSpacing></SectionTitle>
    <div class="product-adv">
      <div>
        <span>1</span>
        <p class="pt5">专业的医学资讯</p>
      </div>
      <div>
        <span>2</span>
        <p>
          个性化的健康干预方案，采集患者的健康指标信息，通过康评估模型给予个性化的干预方案。
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import SectionTitle from '@/components/website_v3/SectionTitle';

export default {
  name: 'jkgl',
  data() {
    return {};
  },
  components: {
    SectionTitle,
  },
};
</script>
<style lang="less" scoped>
.bq-product-jkgl {
  .title-desc {
    color: #333;
    font-size: 18px;
  }

  .desc-list {
    padding: 60px 30px;
    display: flex;
    justify-content: space-between;
    .desc-item {
      h3 {
        width: 263px;
        height: 30px;
        background: rgba(13, 48, 145, 1);
        border-radius: 4px;
        color: #fff;
        font-size: 18px;
        text-align: center;
        margin-bottom: 0;
      }

      .desc-mid {
        padding: 20px 0 10px;
        display: flex;
        justify-content: space-between;
        span {
          display: inline-block;
          width: 124px;
          height: 30px;
          line-height: 30px;
          color: #0d3091;
          font-size: 14px;
          text-align: center;
          border-radius: 2px;
          border: 1px solid rgba(13, 48, 145, 1);
          &:first-child {
            margin-right: 5px;
          }
          &:last-child {
            margin-left: 5px;
          }
        }
      }

      .desc-bot {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 263px;
        height: 75px;
        border-radius: 2px;
        border: 1px solid rgba(13, 48, 145, 1);
        text-align: center;
        p {
          color: #0d3091;
          font-size: 14px;
        }
      }
    }
  }

  .pt5 {
    padding-top: 5px;
  }

  .product-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 60px;

    &:last-child {
      margin-bottom: 90px;
    }
    div {
      width: 425px;
      color: #333;
      h3 {
        font-size: 20px;
        margin-bottom: 20px;
      }
      p {
        font-size: 18px;
      }
    }

    img {
      max-width: 432px;
      max-height: 232px;
    }
  }

  .product-adv {
    display: flex;

    div {
      width: 50%;
      display: flex;

      &:last-child {
        display: flex;
      }
    }

    span {
      display: inline-block;
      text-align: center;
      min-width: 38px;
      height: 38px;
      background: rgba(13, 48, 145, 1);
      color: #fff;
      font-size: 24px;
      font-weight: 500;
      border-radius: 50%;
      margin-right: 20px;
    }

    p {
      color: #333;
      font-size: 18px;
    }
  }

  /deep/ .bq-infobox {
    p {
      font-size: 18px;
    }
  }

  /deep/ .header-title {
    padding-bottom: 0;
    margin-bottom: 60px;
  }
}
</style>
